import { Navigate } from "react-router-dom";
import { useSessionStorage } from "usehooks-ts";

function SecureRoute({ element, level = ["Any"] }) {
  const [authcode, ,] = useSessionStorage("authToken", "");
  const [profileData, ,] = useSessionStorage("profileData", "");
  let closedRoute = false;
  if (!level.includes("Any"))
    if (!level.includes(profileData.clearance)) closedRoute = true;
  return (
    (authcode !== "" && authcode !== null && !closedRoute && element) || (
      <Navigate to="/login" />
    )
  );
}
export default SecureRoute;
